// ActionRepository.ts
// Mirrors ConneXt v2 ActionRepository repeatable-action methods.
import { Storage } from "../../../../application/Storage";
import { StorageKeys } from "../../../../data/constants/Constants";
export class ActionRepository {
    static getRepeatablesInConv() {
        return Storage.get(StorageKeys.RepeatablesInConv) || {};
    }
    static setRepeatablesInConv(data) {
        Storage.set(StorageKeys.RepeatablesInConv, data);
    }
    static removeRepeatablesInConv() {
        Storage.remove(StorageKeys.RepeatablesInConv);
    }
    static getRepeatablesInArticle() {
        return Storage.get(StorageKeys.RepeatablesInArticle) || {};
    }
    static setRepeatablesInArticle(data) {
        Storage.set(StorageKeys.RepeatablesInArticle, data);
    }
    static removeRepeatablesInArticle() {
        Storage.remove(StorageKeys.RepeatablesInArticle);
    }
    static getTimeRepeatableActions() {
        return Storage.get(StorageKeys.ConnextTimeRepeatableActions) || {};
    }
    static setTimeRepeatableActions(data) {
        Storage.set(StorageKeys.ConnextTimeRepeatableActions, data);
    }
    static deleteTimeRepeatableActions() {
        Storage.remove(StorageKeys.ConnextTimeRepeatableActions);
    }
    static resetStorage() {
        ActionRepository.deleteTimeRepeatableActions();
        ActionRepository.removeRepeatablesInConv();
        ActionRepository.removeRepeatablesInArticle();
    }
}
